import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";

interface SectionHeadingProps {
  children: ReactNode;
  /** One size down from the page default, for the denser carousel headers. */
  size?: "default" | "small";
}

/**
 * The page's single section-title treatment. Every band, carousel, and shortcut
 * section uses this so the page reads with one voice — the shared
 * `CarouselHeader` is deliberately not used, since it hardcodes a serif face
 * inline and is shared with other contributors' prototypes.
 */
export function SectionHeading({
  children,
  size = "default",
}: SectionHeadingProps) {
  return (
    <h2
      className={cn(
        "text-fs-text-primary",
        size === "small" ? "type-fs-subheading-medium" : "type-fs-section-heading"
      )}
    >
      {children}
    </h2>
  );
}
